import { applyMiddleware, combineReducers, compose, createStore } from 'redux';

import app from './app/reducer';
import ReduxThunk from 'redux-thunk';

const rootReducer = combineReducers({
  app
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(ReduxThunk))
);
export default store;
